import { useCallback, useMemo, useState } from 'react'

import WebsocketActionsContext from './WebsocketActionsContext'

const WebsocketActionsProvider = ({ children }) => {
  const [pendingActions, setPendingActions] = useState({})

  const setPendingWebsocketAction = useCallback((workspace, action) => {
    setPendingActions(prev => ({ ...prev, [workspace]: action }))
  }, [])

  const clearPendingWebsocketAction = useCallback(workspace => {
    setPendingActions(prev => {
      const next = { ...prev }
      delete next[workspace]

      return next
    })
  }, [])

  const value = useMemo(
    () => ({ pendingActions, setPendingWebsocketAction, clearPendingWebsocketAction }),
    [pendingActions, setPendingWebsocketAction, clearPendingWebsocketAction]
  )

  return <WebsocketActionsContext.Provider value={value}>{children}</WebsocketActionsContext.Provider>
}

export default WebsocketActionsProvider
